import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, X, Trash2 } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { useAuth } from "../context/AuthContext";
import { PageHeader } from "../components/Bits";
import { api, errMsg } from "../lib/api";

const LABEL = { pending: ["Onay Bekliyor", "bg-amber-100 text-amber-800 border-amber-300"], approved: ["Onaylı", "bg-emerald-100 text-emerald-800 border-emerald-300"] };

export default function UsersPage() {
  const { user: me } = useAuth();
  const [users, setUsers] = useState([]);
  const load = () => api.get("/users").then((r) => setUsers(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  const set = async (u, status) => {
    if (status === "rejected" && !window.confirm(`${u.name} reddedilip silinsin mi?`)) return;
    try { await api.patch(`/users/${u.id}/status`, { status }); toast.success(status === "approved" ? `${u.name} onaylandı` : `${u.name} reddedildi ve silindi`); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const setRole = async (u, role) => {
    try { await api.patch(`/users/${u.id}/role`, { role }); toast.success(`${u.name} yetkisi: ${{ admin: "Yönetici", customer: "Müşteri (sadece kendine sipariş)" }[role] || "Plasiyer"}`); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async (u) => {
    if (!window.confirm(`${u.name} kalıcı olarak silinsin mi?`)) return;
    try { await api.delete(`/users/${u.id}`); toast.success("Kullanıcı silindi"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const pending = users.filter((u) => u.status === "pending").length;
  return (
    <div>
      <PageHeader title="Kullanıcılar" kicker={`${pending} onay bekleyen`} />
      <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white shadow-sm">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left font-mono text-[11px] uppercase tracking-wider text-slate-500">
            <tr><th className="p-4">Ad Soyad</th><th className="p-4">E-posta</th><th className="p-4">Telefon</th><th className="p-4">Yetki</th><th className="p-4">Durum</th><th className="p-4 text-right">İşlem</th></tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} data-testid={`user-row-${u.email}`} className={`border-t border-slate-100 ${u.status === "pending" ? "bg-amber-50/40" : ""}`}>
                <td className="p-4 font-medium">{u.name}</td><td className="p-4 text-slate-600">{u.email}</td><td className="p-4 text-slate-600">{u.phone || "-"}</td>
                <td className="p-4">{u.id === me.id ? "Yönetici (siz)" : (
                  <Select value={u.role} onValueChange={(v) => setRole(u, v)}>
                    <SelectTrigger className="h-8 w-36" data-testid={`user-role-select-${u.email}`}><SelectValue /></SelectTrigger>
                    <SelectContent className="bg-white">
                      <SelectItem value="marketer" data-testid={`user-role-option-marketer-${u.email}`}>Plasiyer</SelectItem>
                      <SelectItem value="customer" data-testid={`user-role-option-customer-${u.email}`}>Müşteri</SelectItem>
                      <SelectItem value="admin" data-testid={`user-role-option-admin-${u.email}`}>Yönetici</SelectItem>
                    </SelectContent>
                  </Select>)}</td>
                <td className="p-4"><span data-testid={`user-status-${u.email}`} className={`rounded-md border px-2 py-0.5 font-mono text-[11px] uppercase ${(LABEL[u.status] || LABEL.pending)[1]}`}>{(LABEL[u.status] || LABEL.pending)[0]}</span></td>
                <td className="p-4 text-right">{u.id !== me.id && <div className="inline-flex gap-2">
                  {u.status !== "approved" && <button data-testid={`user-approve-${u.email}`} onClick={() => set(u, "approved")} className="inline-flex items-center gap-1 rounded-lg bg-emerald-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-emerald-700"><Check className="h-3.5 w-3.5" />Onayla</button>}
                  {u.status === "pending" && <button data-testid={`user-reject-${u.email}`} onClick={() => set(u, "rejected")} className="inline-flex items-center gap-1 rounded-lg border border-rose-300 px-3 py-1.5 text-xs font-semibold text-rose-700 hover:bg-rose-50"><X className="h-3.5 w-3.5" />Reddet</button>}
                  {u.status === "approved" && <button data-testid={`user-delete-${u.email}`} onClick={() => remove(u)} className="inline-flex items-center gap-1 rounded-lg border border-rose-300 px-3 py-1.5 text-xs font-semibold text-rose-700 hover:bg-rose-50"><Trash2 className="h-3.5 w-3.5" />Sil</button>}
                </div>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
